import { createContext } from '@lit/context';
import { Article, Product } from '../../@types/wishlist.js';

export interface SizeLayerState {
  product: Product | null;
  selectedArticle: Article | null;
  trackingContext: string;
  triggerA2C: boolean;
  open: boolean;
  update: (newState: Partial<SizeLayerState>) => void;
  backButtonCallback?: () => void;
}

export const sizeLayerContext = createContext<SizeLayerState>('sizeLayerContext');
